import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initTheme } from './ui/theme';
import './styles.css';

/* The inline script in index.html has already stamped `data-theme` before the
   first paint. This re-applies the same stored value so the `theme-color` meta
   agrees with it, and so the app is not depending on the HTML shell having
   been served by this repo's own index.html. */
initTheme();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
